export enum BfxApplicationNotificationCommand {
  // GENERAL
  POPUP_CLOSE,
  // FOOTER COMMANDS
  POPUP_VIEW_ORDER,
  POPUP_VIEW_DEAL,
  POPUP_VIEW_DI,
  POPUP_VIEW_OPS,
}
